<template>
    <v-container fluid>
        <dynamic-toolbar
            :icon="'mdi-account-group'"
            :title="'IT Support'"
            :color="'blue'"
            :theme="'dark'"
            :loading="loading"
        />
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title>
                        Search for {{ type.display }}
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="2">
                                <v-select
                                    v-model="type"
                                    prepend-inner-icon="mdi-filter"
                                    label="Search type"
                                    :items="types"
                                    item-text="text"
                                    item-value="value"
                                    return-object
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="search"
                                    prepend-inner-icon="mdi-magnify"
                                    label="Input ID"
                                    outlined
                                    hide-details
                                    type="text"
                                    autocomplete="on"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" align-self="center">
                                <v-btn
                                    color="info"
                                    text
                                    xlarge
                                    @click="getModel"
                                >
                                    <v-icon left>mdi-database-search</v-icon>
                                    Get {{ type.display }}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="4"> </v-col>
                        </v-row>
                        <v-row v-if="model">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <span class="black--text">
                                            <v-icon>mdi-information</v-icon>
                                            {{ type.display }} Information
                                        </span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                md="3"
                                                v-for="property in properties"
                                                :key="property.key"
                                            >
                                                <v-text-field
                                                    v-model="
                                                        model[property.key]
                                                    "
                                                    :label="property.label"
                                                    outlined
                                                    hide-details
                                                    type="text"
                                                    autocomplete="on"
                                                    :readonly="
                                                        property.key ==
                                                            'OrderID' ||
                                                            property.key ==
                                                                'ShiftDetailID'
                                                    "
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                            <template v-if="type.value == 'shiftDetail'">
                                <v-list>
                                    <v-list-item v-for="order in model.orders">
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Order ID: {{ order.OrderID }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                Order Status:
                                                {{ order.OrderStatus }}
                                            </v-list-item-subtitle>
                                            <v-progress-linear
                                                :color="
                                                    order.Finalize
                                                        ? 'success'
                                                        : 'warning'
                                                "
                                                height="25"
                                                label
                                                dark
                                                :value="
                                                    order.Finalize ? 100 : 0
                                                "
                                                :indeterminate="
                                                    order.Finalize
                                                        ? false
                                                        : true
                                                "
                                            >
                                                {{
                                                    order.Finalize
                                                        ? 'Finalized'
                                                        : 'Not Finalized'
                                                }}
                                            </v-progress-linear>
                                            <v-btn
                                                color="info"
                                                text
                                                @click="
                                                    toggleModel(
                                                        'order',
                                                        order.OrderID
                                                    )
                                                "
                                            >
                                                <v-icon left>
                                                    {{
                                                        !order.Finalize
                                                            ? 'mdi-lock-open-variant'
                                                            : 'mdi-lock'
                                                    }}
                                                </v-icon>
                                                {{
                                                    !order.Finalize
                                                        ? 'Close Order'
                                                        : 'Open Order'
                                                }}
                                            </v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </template>
                        </v-row>
                        <v-row v-if="model">
                            <v-toolbar v-if="!isMobile">
                                <v-toolbar-title>Results</v-toolbar-title>
                                <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                                ></v-divider>
                                <v-btn color="info" text @click="getModel">
                                    <v-icon left>mdi-database-search</v-icon>
                                    Refresh
                                </v-btn>
                                <v-btn
                                    color="info"
                                    text
                                    @click="viewInformation = !viewInformation"
                                >
                                    <v-icon left>mdi-information</v-icon>
                                    {{
                                        viewInformation
                                            ? 'Hide Information'
                                            : 'View Information'
                                    }}
                                </v-btn>
                                <!--Open/Close order or shift-->
                                <v-btn
                                    :color="isModelActive ? 'success' : 'error'"
                                    text
                                    @click="toggleModel()"
                                >
                                    <v-icon left>
                                        {{
                                            isModelActive
                                                ? 'mdi-lock-open-variant'
                                                : 'mdi-lock'
                                        }}
                                    </v-icon>
                                    {{
                                        isModelActive
                                            ? type.display + ' is Open'
                                            : type.display + ' is Closed'
                                    }}
                                    <v-tooltip bottom activator="v-btn">
                                        Click to
                                        {{
                                            isModelActive
                                                ? ' Close ' + type.display
                                                : ' Open ' + type.display
                                        }}
                                    </v-tooltip>
                                </v-btn>
                                <v-btn
                                    v-if="type.value == 'order'"
                                    color="info"
                                    text
                                    @click="openEleosCompareDialog = true"
                                >
                                    <v-icon left>
                                        mdi-compare-horizontal
                                    </v-icon>
                                    Compare with ELEOS
                                </v-btn>
                                <v-btn
                                    v-if="type.value == 'shiftDetail'"
                                    color="info"
                                    text
                                    disabled
                                    @click="resetMailCount()"
                                >
                                    <v-icon left>mdi-email</v-icon>
                                    Reset Mail Count
                                </v-btn>
                                <v-btn color="info" text disabled>
                                    <v-icon left>mdi-printer</v-icon>
                                    Print
                                </v-btn>
                                <v-divider inset vertical></v-divider>
                                <v-btn color="success" text disabled>
                                    Save Changes
                                </v-btn>
                            </v-toolbar>
                        </v-row>
                        <v-row v-if="viewInformation">
                            <v-col cols="12" md="6">
                                <h2>{{ type.display }} Details</h2>
                                <v-skeleton-loader
                                    v-if="!model"
                                    loading-text="Loading..."
                                    type="list-item-three-line"
                                    :loading="loading"
                                ></v-skeleton-loader>
                                <div v-else>
                                    <vue-json-pretty
                                        v-model="model"
                                        :editable="true"
                                        :showIcon="true"
                                    />
                                    <v-textarea
                                        v-model="model.Notes"
                                        label="Notes"
                                        outlined
                                        hide-details
                                        type="text"
                                        autocomplete="on"
                                    >
                                    </v-textarea>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6">
                                <h2>Activity Log</h2>
                                <v-skeleton-loader
                                    v-if="!activity_log"
                                    loading-text="Loading..."
                                    type="list-item-three-line"
                                    :loading="loading"
                                ></v-skeleton-loader>
                                <div v-else>
                                    <v-list
                                        v-for="log in activity_log"
                                        :key="log.id"
                                    >
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon
                                                    :color="
                                                        logType(
                                                            log.description,
                                                            'color'
                                                        )
                                                    "
                                                    >{{
                                                        logType(
                                                            log.description,
                                                            'icon'
                                                        )
                                                    }}</v-icon
                                                >
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{
                                                        log.log_name +
                                                            ' - ' +
                                                            log.description
                                                    }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{
                                                        new Date(
                                                            log.created_at
                                                        ).toLocaleString()
                                                    }}
                                                </v-list-item-subtitle>

                                                <vue-json-pretty
                                                    v-model="log.properties"
                                                    :editable="false"
                                                    :showIcon="true"
                                                />
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </div>
                            </v-col>
                        </v-row>
                        <!--<pre>{{ JSON.stringify(model, null, 2) }}</pre>-->
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <CompareWithELEOS
            v-if="openEleosCompareDialog"
            :order="model"
            :dialogStatus="openEleosCompareDialog"
            @update:dialogStatus="openEleosCompareDialog = $event"
        ></CompareWithELEOS>
        <v-bottom-navigation v-if="isMobile && model" color="info" app>
            <v-btn color="info" text @click="getModel">
                <v-icon left>mdi-database-search</v-icon>
                Refresh
            </v-btn>
            <v-btn
                color="info"
                text
                @click="viewInformation = !viewInformation"
            >
                <v-icon left>mdi-information</v-icon>
                {{ viewInformation ? 'Hide Information' : 'View Information' }}
            </v-btn>
            <!--Open/Close order or shift-->
            <v-btn
                :color="isModelActive ? 'success' : 'error'"
                text
                @click="toggleModel()"
            >
                <v-icon left>
                    {{ isModelActive ? 'mdi-lock-open-variant' : 'mdi-lock' }}
                </v-icon>
                {{
                    isModelActive
                        ? type.display + ' is Open'
                        : type.display + ' is Closed'
                }}
                <v-tooltip bottom activator="v-btn">
                    Click to
                    {{
                        isModelActive
                            ? ' Close ' + type.display
                            : ' Open ' + type.display
                    }}
                </v-tooltip>
            </v-btn>
            <v-btn
                v-if="type.value == 'order'"
                color="info"
                text
                @click="openEleosCompareDialog = true"
            >
                <v-icon left>
                    mdi-compare-horizontal
                </v-icon>
                Compare with ELEOS
            </v-btn>
        </v-bottom-navigation>
    </v-container>
</template>

<script>
import axios from 'axios';

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import DynamicToolbar from '../../components/Global/Utils/DynamicToolbar.vue';

import CompareWithELEOS from '../../components/it/DispatchSupport/CompareWithELEOS.vue';
export default {
    name: 'ITSupport',
    components: {
        VueJsonPretty,
        DynamicToolbar,
        CompareWithELEOS
    },
    data: () => ({
        search: '',
        types: [
            {
                value: 'order',
                text: 'Order ID',
                display: 'Order',
                model: 'Order'
            },
            {
                value: 'shiftDetail',
                text: 'ShiftDetail ID',
                display: 'ShiftDetail',
                model: 'ShiftDetail'
            }
        ],
        type: {},
        model: null,
        activity_log: null,
        isModelActive: false,
        loading: false,
        openEleosCompareDialog: false,
        viewInformation: false,
        isMobile: false
    }),
    mounted() {
        this.type = this.types[0];
        console.log('Breakpoint', this.$vuetify.breakpoint);
        this.isMobile = this.$vuetify.breakpoint.mobile;
    },
    computed: {
        auth() {
            return {
                headers: {
                    Authorization: 'Bearer ' + this.$store.state.token
                }
            };
        },
        properties() {
            if (this.type.value == 'order') {
                return [
                    { key: 'OrderID', label: 'Order ID' },
                    { key: 'OrderStatus', label: 'Order Status' },
                    { key: 'ShiftDetail', label: 'Shift Detail ID' },
                    { key: 'BillOfLading', label: 'Bill Of Lading' },
                    { key: 'LoadNum', label: 'Load Number' },
                    { key: 'OrdLoadStatus', label: 'Order Load Status' },
                    { key: 'OrdActiveOrder', label: 'Order Active' },
                    { key: 'Finalize', label: 'Finalize' }
                ];
            } else if (this.type.value == 'shiftDetail') {
                return [
                    { key: 'ShiftDetail', label: 'Shift Detail ID' },
                    { key: 'ShiftHeaderNum', label: 'Shift Header ID' },
                    { key: 'Finalize', label: 'Finalize' },
                    { key: 'DispatchFinalize', label: 'Dispatch Finalize' }
                ];
            }
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'IT Support';
            }
        },
        type: {
            immediate: true,
            handler() {
                this.search = '';
                this.model = null;
                this.activity_log = null;
            }
        }
    },
    methods: {
        highlightOrder(item) {
            if (item.id == this.search) {
                return 'highlight';
            }
        },
        getModel() {
            this.loading = true;
            this.model = null;
            this.activity_log = null;
            //Issue a setSnackbar
            this.$store.dispatch('setSnackbar', {
                text: 'Loading...',
                color: 'info',
                timeout: 3000
            });
            axios
                .get(`/v2/it/support/search/${this.type.value}/${this.search}`)

                .then(response => {
                    this.model = response.data;
                    this.loading = false;
                    this.isModelActive = this.getModelStatus();
                    this.getActivityLog();
                })
                .catch(error => {
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error loading ' + this.type.display,
                        color: 'error',
                        timeout: 3000
                    });
                    this.loading = false;
                    alert(error.message);
                    console.log(error);
                });
        },
        getActivityLog() {
            this.$store.dispatch('setSnackbar', {
                text: 'Loading activity log...',
                color: 'info',
                timeout: 3000
            });
            this.loading = true;
            axios
                .get(`/v2/it/support/logs/${this.type.model}/${this.search}`)

                .then(response => {
                    this.activity_log = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error loading activity log',
                        color: 'error',
                        timeout: 3000
                    });
                    this.loading = false;
                });
        },
        getModelStatus() {
            let model = this.model;
            console.log('Model: ', model);
            if (model.Finalize) {
                console.log('Finalize: ' + model.Finalize);
                if (model.Finalize == 1) {
                    return false;
                } else if (model.Finalize == 0) {
                    return true;
                }
            } else if (model.OrdActiveOrder) {
                console.log('OrdActiveOrder: ' + model.OrdActiveOrder);
                if (model.OrdActiveOrder == 1) {
                    return true;
                } else if (model.OrdActiveOrder == 0) {
                    return false;
                }
            } else if (model.DispatchFinalize) {
                console.log('DispatchFinalize: ' + model.DispatchFinalize);
                if (model.DispatchFinalize == 1) {
                    return false;
                } else if (model.DispatchFinalize == 0) {
                    return true;
                }
            } else {
                console.log('No status found, model might be active');
                return true;
            }
        },
        toggleModel(type = this.type.value, id = this.search) {
            if (
                window.confirm(
                    'Are you sure you want to toggle the status of this ' +
                        this.type.display +
                        '?'
                )
            ) {
                //this.isModelActive = !this.isModelActive;
                axios
                    .put(`/v2/it/support/toggle/${type}/${id}`)
                    .then(response => {
                        this.$store.dispatch('setSnackbar', {
                            text: 'Status toggled successfully',
                            color: 'success',
                            timeout: 3000
                        });
                        console.log(response);
                        this.getModel();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$store.dispatch('setSnackbar', {
                            text: 'Error toggling status',
                            color: 'error',
                            timeout: 3000
                        });
                    });
            }
        },
        logType(event, type) {
            if (type === 'color') {
                switch (event) {
                    case 'created':
                        return 'green';
                    case 'updated':
                        return 'blue';
                    case 'deleted':
                        return 'red';
                    default:
                        return 'grey';
                }
            } else if (type === 'icon') {
                switch (event) {
                    case 'created':
                        return 'mdi-plus';
                    case 'updated':
                        return 'mdi-pencil';
                    case 'deleted':
                        return 'mdi-delete';
                    default:
                        return 'mdi-help';
                }
            }
        }
    }
};
</script>

<style>
.highlight {
    background-color: #1eff00 !important;
}
</style>
